
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class InfoBtn extends Vue {
  @Prop({ default: 'image' }) theme: string
  @Prop({ default: 'auto' }) placement: string
  @Prop({ default: false }) whitebg: boolean
}
